// extracted by mini-css-extract-plugin
export var container = "_5w-0";
export var fallback = "_5w-5";
export var fallbackIcon = "_5w-6";
export var hidden = "_5w-2";
export var image = "_5w-3";
export var loaded = "_5w-4";
export var placeholder = "_5w-1";